module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab138-7038818dcf9cc79ba1f07b31e5030423.jpg";